import { useState } from 'react';
import { useEmployee } from './EmployeeContext';
import { todayStr } from '../../lib/format';
import { AlterarPinForm } from './AlterarPinForm';

const DISMISS_KEY = 'coala.pinNudgeDismissDate';

/** Sugere (sem obrigar) trocar a senha padrão (últimos 4 dígitos do
 * telefone) por uma escolhida pelo próprio funcionário — some de vez
 * assim que ele trocar alguma vez (pin_alterado_pelo_funcionario). Até lá,
 * reaparece no máximo 1x por dia (dá pra adiar em "Agora não"). */
export function TrocarSenhaNudge() {
  const { employee } = useEmployee();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === todayStr());
  const [expanded, setExpanded] = useState(false);

  if (employee.pinAlteradoPeloFuncionario || dismissed) return null;

  function agoraNao() {
    localStorage.setItem(DISMISS_KEY, todayStr());
    setDismissed(true);
  }

  if (expanded) {
    return (
      <div className="card">
        <h2>Trocar minha senha</h2>
        <p className="hint">Escolha uma senha sua, mantendo o formato de 4 números.</p>
        <AlterarPinForm onDone={() => setExpanded(false)} />
        <button className="btn btn-ghost btn-block" style={{ marginTop: 8 }} onClick={() => setExpanded(false)}>Cancelar</button>
      </div>
    );
  }

  return (
    <div className="banner" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
      <div>
        <b>🔐 Quer trocar sua senha?</b> Você ainda está usando o PIN inicial gerado pelo gestor — pode trocar por um seu, mantendo os 4 números.
      </div>
      <div style={{ display: 'flex', gap: 8, flex: 'none' }}>
        <button className="btn btn-primary btn-sm" onClick={() => setExpanded(true)}>Trocar agora</button>
        <button className="btn btn-ghost btn-sm" onClick={agoraNao}>Agora não</button>
      </div>
    </div>
  );
}
